import * as THREE from 'three';

import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { HDRLoader } from 'three/addons/loaders/HDRLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';

//import Stats from 'three/addons/libs/stats.module.js';

import { useNeedleProgressive } from '@needle-tools/gltf-progressive';

import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
gsap.registerPlugin(MotionPathPlugin);

import { detectDeviceProfile } from "../utils/deviceprofiler.mod.js";
import "./three.css";

const profile = detectDeviceProfile();
console.log('device profil: ', profile);

// -----------------------------------------------------------------------------
// PUBLIC FACTORY (NO SIDE EFFECTS ON IMPORT)
// -----------------------------------------------------------------------------
export function FantasyProgressive() {

    // --- VARIABLES (GLOBAL TO MODULE INSTANCE) ---
    let camera, scene, renderer, mixer;
    let airshipModel;
    let controls;
    let container;
//    let stats;
let animating = false;
    let publicScrubCamera;
	
	let needsRender = true;
    let hasActiveAnimation = false;


    const clock = new THREE.Clock();
    let time = 0;

	runIdle(() => {
    initPhase1();
 //   animate();
//    renderer.render(scene, camera);
	
//renderer.render(scene, camera); // one frame

});

let hasFadedIn = false;
//let storedModel = null;

function startAnimation() {
  if (animating) return;
  animating = true;
//  if (hasntloaded) return;

//  hasActiveAnimation = true;

//  if (!hasFadedIn && storedModel) {
//    fadeInModel(storedModel, 1);
//    hasFadedIn = true;
//  }
  
  requestAnimationFrame(animate);
  gsap.to(container, {
        opacity: 1,
        duration: 1.5,
        ease: "power2.out",
        onUpdate: () => { needsRender = true; }
    });
}

//window.addEventListener('pointerdown', startAnimation, { once: true });
//window.addEventListener('wheel', startAnimation, { once: true });


let isModelReady = false;

function handleInteraction(event) {
    // If model isn't ready, just "sink" the event and wait for the next one
    if (!isModelReady) {
        console.log("Input received, but model is still loading...");
        return; 
    }

    // Success: Model is ready, start the sequence
    startAnimation();

    // Clean up: Now that we started, we stop listening
    window.removeEventListener('pointerdown', handleInteraction);
    window.removeEventListener('wheel', handleInteraction);
    window.removeEventListener('keydown', handleInteraction);
}

// Start without "once: true"
window.addEventListener('pointerdown', handleInteraction);
window.addEventListener('wheel', handleInteraction);	
window.addEventListener('keydown', handleInteraction);	
	
	
/* 	function fadeInModel(root, duration = 1.6) {
    const materials = [];

    root.traverse(obj => {
        if (obj.material) {
            const mats = Array.isArray(obj.material)
                ? obj.material
                : [obj.material];

            mats.forEach(mat => {
                mat.transparent = true;
                mat.opacity = 0;
                mat.depthWrite = false; // avoids popping during fade
                materials.push(mat);
            });
        }
    });

	gsap.to(materials, {
    opacity: 1,
    duration,
    ease: 'power1.out',
    onUpdate: () => needsRender = true,
    onComplete: () => {
        materials.forEach(mat => {
            mat.depthWrite = true;
        });
    }
});

} */

/* function fadeInModel(root, duration = 1.0) {
    const materials = [];
    root.traverse(obj => {
        if (obj.material) {
            const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
            mats.forEach(m => materials.push(m));
        }
    });

    gsap.to(materials, {
        opacity: 1,
        duration: duration,
        ease: 'power1.inOut',
        onUpdate: () => { needsRender = true; }, // Ensure frame triggers
        onComplete: () => {
            materials.forEach(mat => {
                // Only turn depthWrite back on if the material is fully opaque
                mat.depthWrite = true; 
            });
        }
    });
} */

function runIdle(fn) {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => fn(), { timeout: 100 });
    } else {
        setTimeout(fn, 0);
    }
}

/* function scheduleRender() {
  if (animating) return;
  animating = true;
  requestAnimationFrame(() => {
    renderer.render(scene, camera);
    animating = false;
  });
} */


    // -------------------------------------------------------------------------
    // INIT
    // -------------------------------------------------------------------------
 
 function initPhase1() {

    // ---------------- LOADING PROGRESS STATE ----------------
    let visualProgress = 10;
    let realProgress = 0;
    let loadingInterval = null;

    const progContainer = document.getElementById('tprogress-cont');
    const progText = document.getElementById('tprogress-txt');
    const progBar = document.getElementById('tprogress');

 //   const container = document.querySelector('.threediv');
    container = document.querySelector('.threediv');
	if (container) {
        container.style.opacity = "0";
        container.style.transition = "none";
    }

    scene = new THREE.Scene();

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(container.clientWidth, container.clientHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2) * profile.resolutionScale);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1;

    camera = new THREE.PerspectiveCamera(40, container.clientWidth / container.clientHeight, 0.1, 100);
    gsap.set(camera.position, { x: 6.22, y: -3.85, z: 17.68 });

    scene.fog = new THREE.Fog('#131055', 15, 50);

    runIdle(initPhase2);
}

function initPhase2() {

//    const container = document.querySelector('.threediv');

    controls = new OrbitControls(camera, renderer.domElement);
    controls.minDistance = 0.1;
    controls.maxDistance = 120;
    gsap.set(controls.target, { x: -1.0, y: 2.1, z: 0 });

    controls.addEventListener('change', () => {
        needsRender = true;
    });

    // ---------------- HDR SELECTION ----------------
    const hdr1k = new URL('/assets/textures/quarry_01_vers/quarry_01_1k.hdr', import.meta.url).href;
    const hdr512 = new URL('/assets/textures/quarry_01_vers/quarry_01_512.hdr', import.meta.url).href;
    const hdr256 = new URL('/assets/textures/quarry_01_vers/quarry_01_256.hdr', import.meta.url).href;

    let selectedHDR = hdr1k;
    if (profile.resolutionScale < 0.75) selectedHDR = hdr512;
    if (profile.resolutionScale < 0.5) selectedHDR = hdr256;

    new HDRLoader().load(selectedHDR, (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        scene.background = new THREE.Color('#192022');
 //       scene.backgroundBlurriness = 0.5;
        scene.environment = texture;
        scene.environmentRotation = new THREE.Euler(0, Math.PI / -2, 0, 'XYZ');
        needsRender = true;
    });

    mixer = new THREE.AnimationMixer(scene);

    runIdle(initPhase3);
}


function initPhase3() {

    const loader = new GLTFLoader();
	
//	loader.setCrossOrigin('anonymous');/////////////////////
	
    const manager = THREE.DefaultLoadingManager;

    // ---------------- PROGRESS HEARTBEAT ----------------
    let visualProgress = 10;
    let realProgress = 0;

    const progContainer = document.getElementById('tprogress-cont');
    const progText = document.getElementById('tprogress-txt');
    const progBar = document.getElementById('tprogress');

    const loadingInterval = setInterval(() => {
        if (realProgress > visualProgress) visualProgress = realProgress;
        else visualProgress += visualProgress > 90 ? 0.01 : 0.1;

        const rounded = Math.floor(visualProgress);
        if (progText) progText.textContent = rounded + '%';
        if (progBar) progBar.style.height = visualProgress + '%';

        if (visualProgress > 99) {
            clearInterval(loadingInterval);
            if (progContainer) {
                progContainer.classList.add('skrj');
                setTimeout(() => {
                    if (progContainer.parentNode) progContainer.parentNode.removeChild(progContainer);
                }, 500);
            }
        }
    }, 100);

    manager.onProgress = (url, itemsLoaded, itemsTotal) => {
        realProgress = (itemsLoaded / itemsTotal) * 100;
    };

    manager.setURLModifier((url) => {
        if (url.includes('draco_decoder')) return './draco/gltf/' + url.split('/').pop();
        if (url.includes('basis') || url.includes('ktx2')) return './basis/' + url.split('/').pop();
        return url;
    });

    useNeedleProgressive(loader, renderer);

/*     loader.load('https://cloud.needle.tools/-/assets/Z23hmXBZ2sPRdk-world/file', (gltf) => {
        const model = gltf.scene;
        model.scale.multiplyScalar(0.1);
        scene.add(model); 
//		renderer.render(scene, camera); 

//  runIdle(() => {
//    renderer.compile(scene, camera); // PREPARE GPU
//    needsRender = true;
//  });
  
//        fadeInModel(model, 1);
//        gltf.animations.forEach(a => mixer.clipAction(a).play());
        gltf.animations.forEach(a => {const action = mixer.clipAction(a);action.play();action.time = 3.5;});
		mixer.update(0);
        hasActiveAnimation = true;
        needsRender = true;
//		storedModel = model;
//		renderer.render(scene, camera);
//        scheduleRender(); 
console.log('tis ready');
    }); */
	
// Fantazija
    loader.load('https://cloud.needle.tools/-/assets/Z23hmXBZ2sPRdk-world/file', (gltf) => {
        const model = gltf.scene;
        model.scale.multiplyScalar(0.1);
        scene.add(model); 
        gltf.animations.forEach(a => {const action = mixer.clipAction(a);action.play();action.time = 3.5;});
		mixer.update(0);
        hasActiveAnimation = true;
        needsRender = true;
//        console.log('tis ready');
		isModelReady = true;
		
		// export bit:
/* 		renderer.render(scene, camera);
		const heroImageURL = renderer.domElement.toDataURL("image/webp", 0.9);
	    const link = document.createElement('a');
        link.setAttribute('download', 'hero_fallback_frame.webp');
        link.setAttribute('href', heroImageURL);
        link.click(); */
    });	
	

/*     if (profile.loadHeavyModels) {
        loader.load('https://cloud.needle.tools/-/assets/Z23hmXBZnlceI-ZnlceI-world/file', (gltf) => {
            airshipModel = gltf.scene;
            airshipModel.scale.multiplyScalar(0.0005);
            airshipModel.position.set(1.6, 2, 7);
            airshipModel.rotation.set(0, Math.PI * 1.4, 0);
            scene.add(airshipModel);
            fadeInModel(airshipModel, 1);
            gltf.animations.forEach(a => mixer.clipAction(a).play());
            hasActiveAnimation = true;
            needsRender = true;
//			renderer.render(scene, camera);
        });
    } */

// GRAMOFON	
/* 	const gramofonPath = "./models/gramofon2/scene.glb";
    loader.load( gramofonPath, function ( gltf ) {
    const model = gltf.scene;
    model.scale.multiplyScalar( 2 );
    model.position.set( 1.6, -1, 7);
    model.rotation.set( Math.PI * 0.2, 0, 0 );
    scene.add( model );
	
    const animations = gltf.animations;
    if ( animations && animations.length ) {
        for ( const animation of animations ) { 
           mixer.clipAction( animation ).play(); 
			//const action = mixer.clipAction(animation);action.play();action.time = 2.5;
        }
    }
    hasActiveAnimation = true;
    needsRender = true;
//	storedModel = model;	
	console.log('tis ready');
	isModelReady = true;
//	startAnimation();
//	renderer.render(scene, camera);
//renderer.compile(scene, camera);	
    }); */
	

    runIdle(initPhase4);
}


function initPhase4() {

//    const container = document.querySelector('.threediv');
    container.appendChild(renderer.domElement);
    window.addEventListener('resize', onWindowResize);

    const camTimeline = gsap.timeline({
        duration: 8,
        paused: true,
        onUpdate: () => {
            controls.update();
            needsRender = true;
        }
    });

    camTimeline
        .set(camera.position, { x: 6.22, y: -3.85, z: 17.68 }, 0)
        .set(controls.target, { x: -1.0, y: 2.1, z: 0 }, 0)
        .to(camera.position, { x: 0.06, y: 1.24, z: 8.01, duration: 1, ease: 'none' }, 2)
        .to(controls.target, { x: -0.15, y: 1.15, z: -0.23, duration: 1 }, 3)
        .to(camera.position, {
            motionPath: {
                path: [
                    { x: -0.2, y: 1.24, z: 8.01 },
                    { x: -0.38, y: 0.99, z: 4.92 },
                    { x: -0.19, y: 1.05, z: 3.81 }
                ],
                curviness: 1
            },
            duration: 1,
            ease: 'none'
        }, 3)
        .to(camera.position, {
            motionPath: {
                path: [
                    { x: -0.19, y: 1.05, z: 3.81 },
                    { x: 11.67, y: 2.36, z: -0.11 }
                ],
                curviness: 1
            },
            duration: 1,
            ease: 'none'
        }, 4)
        .to(camera.position, {
            motionPath: {
                path: [
                    { x: 11.67, y: 2.36, z: -0.11 },
                    { x: 5.76, y: 1.63, z: -10.53 }
                ],
                curviness: 1
            },
            duration: 1,
            ease: 'none'
        }, 5)
        .to(camera.position, { x: -0.25, y: 1.0, z: -4.36, duration: 1 }, 6)
        .to(camera.position, { x: 6.22, y: -3.85, z: 17.68, duration: 1, ease: 'power2.in' }, 7)
        .to(controls.target, { x: -1.0, y: 2.1, z: 0, duration: 1, ease: 'power2.in' }, 7);

    camTimeline.progress(0);
    controls.update();
	
/* 	  needsRender = true;

  requestAnimationFrame(() => {
    renderer.render(scene, camera); // GUARANTEED first paint
  }); */

    publicScrubCamera = (p) => camTimeline.progress(p);
}

 
    function onWindowResize() {
 //       const container = document.querySelector('.threediv');
        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.clientWidth, container.clientHeight);
    }


/* 	function animate() {
    let updated = false;

    if (hasActiveAnimation && mixer) {
        const dt = clock.getDelta();
        mixer.update(dt);
        updated = true;
    }

    if (updated || needsRender) {
        renderer.render(scene, camera);
        needsRender = false;
    }

    requestAnimationFrame(animate); // CASE 1: WE COMMENT THIS OUT; CASE 2: WE INCLUDE IT
} */

function animate() {
  let updated = false;

  if (hasActiveAnimation && mixer) {
    mixer.update(clock.getDelta());
    updated = true;
  }

  if (updated || needsRender) {
    renderer.render(scene, camera);
    needsRender = false;
    requestAnimationFrame(animate);
  } else {
    animating = false; // allow restart later
  }
}

    // ---------------- PUBLIC API ----------------
    return {
        updateAirship: (scrollProgress) => {
            if (airshipModel) airshipModel.rotation.y = scrollProgress * Math.PI * 2;
        },
        scrubCamera: (progress) => {
            if (publicScrubCamera) publicScrubCamera(progress);
        }
    };
}
